<template>
    <div>
        <Modal
            v-model="showModal"
            draggable
            sticky
            title="View Project Log Dispute"
            width="600"
            footer-hide
            class="viewProjectLogDispute"
        >
            <div v-if="details">
                <Row style="margin-bottom: 20px">
                    <Col span="12">
                        <div class="info-label">Date</div>
                        <div class="info-value">{{ formatDate(details.requestedStart) }}</div>
                    </Col>
                    <Col span="12">
                        <div class="info-label">Status</div>
                        <div :class="['statusLabel', statusClass]">{{ details.status.toUpperCase() }}</div>
                    </Col>
                </Row>
                <Row style="margin-bottom: 20px">
                    <Col span="24">
                        <div class="info-label">Project</div>
                        <div class="info-value">
                            {{
                                details.currentData && details.currentData.project
                                    ? details.currentData.project.name
                                    : '-'
                            }}
                        </div>
                    </Col>
                </Row>
                <Row style="margin-bottom: 20px">
                    <Col span="12">
                        <div class="info-label">Initial Time</div>
                        <div class="info-value">
                            {{
                                details.currentData.startTime
                                    ? formatTime(details.currentData.startTime) +
                                      ' - ' +
                                      formatTime(details.currentData.endTime)
                                    : '-'
                            }}
                        </div>
                    </Col>
                    <Col span="12">
                        <div class="info-label">Initial Hours</div>
                        <div class="info-value">
                            {{
                                details.currentData.elapsedTimeInHrs
                                    ? Number(details.currentData.elapsedTimeInHrs).toFixed(2) + ' hours'
                                    : '-'
                            }}
                        </div>
                    </Col>
                </Row>
                <Row style="margin-bottom: 20px">
                    <Col span="12">
                        <div class="info-label">Requested Time</div>
                        <div class="info-value">
                            {{ formatTime(details.requestedStart) }} -
                            {{ formatTime(details.requestedEnd) }}
                        </div>
                    </Col>
                    <Col span="12">
                        <div class="info-label">Requested Hours</div>
                        <div class="info-value">
                            {{
                                details.requestedData && details.requestedData.elapsedTimeInHrs
                                    ? Number(details.requestedData.elapsedTimeInHrs).toFixed(2) + ' hours'
                                    : '-'
                            }}
                        </div>
                    </Col>
                </Row>
                <Row style="margin-bottom: 20px">
                    <Col span="24">
                        <div class="info-label">Reason</div>
                        <div class="info-value">{{ details.reason || '-' }}</div>
                    </Col>
                </Row>
                <div style="text-align: right">
                    <Button class="pt-btn-2" @click="showModal = false">CLOSE</Button>
                </div>
            </div>
            <div v-else class="text-center">No Data</div>
        </Modal>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    data() {
        return {
            showModal: false,
            details: null,
        };
    },
    computed: {
        statusClass() {
            if (!this.details) return '';
            switch (this.details.status) {
                case 'pending':
                    return 'warning';
                case 'approved':
                    return 'success';
                case 'rejected':
                    return 'danger';
                case 'cancelled':
                    return 'primary';
                default:
                    return '';
            }
        },
    },
    methods: {
        openModal(data) {
            this.details = data;
            this.showModal = true;
        },
        formatDate(date) {
            return date ? moment(date).utc().format('YYYY-MM-DD') : '-';
        },
        formatTime(time) {
            return time ? moment(time).utc().format('hh:mm A') : '-';
        },
    },
};
</script>

<style scoped>
.info-label {
    font-weight: bold;
    color: #828899;
    margin-bottom: 5px;
}
.info-value {
    font-size: 14px;
}
.statusLabel {
    display: inline-block;
    color: #fff;
    border-radius: 5px;
    padding: 5px 10px;
    text-align: center;
    font-weight: bold;
}
.success {
    background: #49e97e;
}
.warning {
    background: #ffc107;
}
.danger {
    background: #e9495d;
}
.primary {
    background: #211841;
}
</style>
